module.exports = __webpack_public_path__ + "img/mcgl_fp_03.8a4882b5.png";